/**
 * Medição de performance da aplicação MEDICARE
 * Utiliza as Web Vitals para monitorar métricas importantes
 */

import { ReportHandler } from 'web-vitals';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;

/**
 * Função para enviar métricas para serviço de analytics
 * Pode ser configurada para enviar dados para Google Analytics,
 * DataDog, New Relic, ou outro serviço de monitoramento
 */
export const sendToAnalytics = (metric: any) => {
  // Exemplo de envio para Google Analytics
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', metric.name, {
      event_category: 'Web Vitals',
      event_label: metric.id,
      value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
      non_interaction: true,
    });
  }

  // Exemplo de envio para console em desenvolvimento
  if (process.env.NODE_ENV === 'development') {
    console.log('Web Vital:', metric);
  }

  // Aqui você pode adicionar outros serviços de analytics
  // Exemplo: DataDog, New Relic, Sentry, etc.
};

/**
 * Configuração para desenvolvimento
 * Mostra métricas detalhadas no console
 */
if (process.env.NODE_ENV === 'development') {
  reportWebVitals(sendToAnalytics);
}